(function () {
  var SNIPPET_SELECTOR = '.redeem-reward-products__snippet';
  var MOBILE_SELECTOR = '.yotpo-redemption-mobile-carousel';
  var POLL_INTERVAL = 250;
  var POLL_ATTEMPTS = 60;

  var ARROW_ICON =
    '<svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M9.34 4.75a.85.85 0 0 1 1.2 0l7.85 7.86a.55.55 0 0 1 0 .78l-7.85 7.86a.85.85 0 0 1-1.2-1.2L16.99 13 9.34 5.95a.85.85 0 0 1 0-1.2Z" fill="currentColor"/></svg>';

  function numberToken(element, name, fallback) {
    var value = parseFloat(getComputedStyle(element).getPropertyValue(name));
    return isNaN(value) ? fallback : value;
  }

  function perView(element) {
    var raw = getComputedStyle(element).getPropertyValue('--redeem-slides-per-view').trim();
    if (raw === 'auto') return 'auto';
    var value = parseFloat(raw);
    return isNaN(value) ? 4 : value;
  }

  function flatten(wrapper) {
    if (wrapper.getAttribute('data-redeem-flat') === 'true') return;
    var items = wrapper.querySelectorAll('.yotpo-redemption-slider-item');
    if (items.length < 2) return;

    var fragment = document.createDocumentFragment();
    for (var i = 0; i < items.length; i++) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.setAttribute('role', 'group');
      slide.appendChild(items[i]);
      fragment.appendChild(slide);
    }
    while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
    wrapper.appendChild(fragment);
    wrapper.setAttribute('data-redeem-flat', 'true');
  }

  function addArrows(carousel, swiper) {
    if (carousel.getAttribute('data-redeem-arrows') === 'true') return;

    var buttons = {};
    ['prev', 'next'].forEach(function (direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'redeem-reward-products__arrow redeem-reward-products__arrow--' + direction;
      button.setAttribute('aria-label', direction === 'prev' ? 'Previous product' : 'Next product');
      button.innerHTML = ARROW_ICON;
      button.addEventListener('click', function () {
        if (direction === 'prev') swiper.slidePrev();
        else swiper.slideNext();
      });
      carousel.appendChild(button);
      buttons[direction] = button;
    });

    function sync() {
      buttons.prev.disabled = swiper.isBeginning;
      buttons.next.disabled = swiper.isEnd;
    }
    swiper.on('slideChange', sync);
    swiper.on('update', sync);
    sync();

    carousel.setAttribute('data-redeem-arrows', 'true');
  }

  function bindHeaderArrows(container, swiper) {
    var section = container.closest('.section-redeem-reward-products');
    if (!section || section.getAttribute('data-nav-ready') === 'true') return;

    var prev = section.querySelector('.redeem-reward-products__nav-btn--prev');
    var next = section.querySelector('.redeem-reward-products__nav-btn--next');
    if (!prev || !next) return;

    prev.addEventListener('click', function () { swiper.slidePrev(); });
    next.addEventListener('click', function () { swiper.slideNext(); });

    function sync() {
      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;
    }
    swiper.on('slideChange', sync);
    swiper.on('update', sync);
    sync();

    section.setAttribute('data-nav-ready', 'true');
  }

  function tune(container) {
    var swiper = container.swiper;
    if (!swiper || swiper.destroyed || !swiper.params) return false;

    var carousel = container.closest(MOBILE_SELECTOR);
    if (carousel) flatten(swiper.wrapperEl || container.querySelector('.swiper-wrapper'));

    var slidesPerView = perView(container);
    var spaceBetween = numberToken(container, '--redeem-slide-gap', 16);

    if (swiper.params.slidesPerView !== slidesPerView || swiper.params.spaceBetween !== spaceBetween) {
      swiper.params.slidesPerView = slidesPerView;
      swiper.params.spaceBetween = spaceBetween;
      swiper.update();
    }

    if (carousel) addArrows(carousel, swiper);
    else bindHeaderArrows(container, swiper);
    return true;
  }

  function scan() {
    var containers = document.querySelectorAll(SNIPPET_SELECTOR + ' .swiper-container');
    var pending = false;
    for (var i = 0; i < containers.length; i++) {
      if (!tune(containers[i])) pending = true;
    }
    return containers.length > 0 && !pending;
  }

  function init() {
    var snippets = document.querySelectorAll(SNIPPET_SELECTOR);
    if (window.MutationObserver) {
      for (var i = 0; i < snippets.length; i++) {
        new MutationObserver(function (records, observer) {
          observer.disconnect();
          scan();
          observer.observe(this.target, { childList: true, subtree: true });
        }.bind({ target: snippets[i] })).observe(snippets[i], { childList: true, subtree: true });
      }
    }
    window.addEventListener('resize', scan);
    if (scan()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      if (scan() || ++attempts >= POLL_ATTEMPTS) clearInterval(timer);
    }, POLL_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
